import React from "react";

interface InputProps {
  id: string;
  name: string;
  type?: string;
  label?: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  error?: string;
  required?: boolean;
  autoComplete?: string;
  placeholder?: string;
  rows?: number;
  as?: "input" | "textarea";
  className?: string;
}

const Input: React.FC<InputProps> = ({
  id,
  name,
  type = "text",
  label,
  value,
  onChange,
  error,
  required = false,
  autoComplete,
  placeholder,
  rows = 4,
  as = "input",
  className = "",
}) => {
  const baseInputClasses =
    "block w-full rounded-md border-0 py-1.5 px-3.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 dark:bg-gray-700 dark:focus:ring-indigo-500 sm:text-sm sm:leading-6";

  const baseLabelClasses =
    "block text-sm font-medium leading-6 text-gray-900 dark:text-gray-300";

  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className={baseLabelClasses}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className={label ? "mt-2" : ""}>
        {as === "textarea" ? (
          <textarea
            id={id}
            name={name}
            rows={rows}
            value={value}
            onChange={onChange}
            required={required}
            autoComplete={autoComplete}
            placeholder={placeholder}
            className={baseInputClasses}
          />
        ) : (
          <input
            id={id}
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            required={required}
            autoComplete={autoComplete}
            placeholder={placeholder}
            className={baseInputClasses}
          />
        )}
        {error && (
          <p className="mt-2 text-sm text-red-600 dark:text-red-400">{error}</p>
        )}
      </div>
    </div>
  );
};

export default Input;
